<template>
  <div class="home">
    <HeaderComponent />
    <ContractVehiclesBannerComponent 
      imageSrc="contracts-banner.jpg"
      heading="About Us"
    />
    <div class="paragraph-container" data-aos="fade-up">
      <div class="paragraph-content">       
        <div class="d-flex mb-6 align-center">
          <img
            :src="require('@/assets/about us/SDVOSB_Logo.jpg')"
            class="ml-n3"
            height="180"
          >
          <div class="ml-7">
            G14C, LLC is a Service-Disabled Veteran Owned Small Business (SDVOSB) and Economically Disadvantaged Woman Owned Small Business (EDWOSB) Joint Venture (JV) Mentor-Protégé (MP) company, forged from the strength of collaboration and a commitment to excellence. With over 45 years of combined experience, we bring a wealth of knowledge and proven success to both the U.S. Federal, National Security and Public sectors.
          </div>
        </div>  
        At G14C, we're dedicated to delivering innovative and impactful solutions across a broad spectrum of critical areas. We combine the expertise of Assyst, Inc. (Mentor) and Everest Capitol Group, LLC (Protégé) to offer a comprehensive suite of services. We specialize in transformative IT solutions, including application modernization, cloud computing, cyber security, DevSecOps, and digital services. We also provide data-driven insights through artificial intelligence and machine learning, and business intelligence. Furthermore, we offer strategic guidance in program management and strategy, and deliver actionable intelligence with our expertise in All-Source Intelligence to include Signals Intelligence (SIGINT), Geospatial-Intelligence (GEOINT), Imagery Intelligence (IMINT), Human Intelligence (HUMINT), and Open-Source Intelligence (OSINT). Additionally, we provide comprehensive support through our management and advisory, technical and engineering, and research and development services.
        <br><br>
        We understand the unique challenges and demands of the Federal government and the Public Sector. Having successfully supported over 40 distinct Federal and National Security customers, we are passionate about improving government efficiency, empowering employees, and enhancing services for citizens and industry partners. G14C, LLC is more than just a contractor; we are a trusted partner, dedicated to providing innovative, reliable, and impactful solutions that drive mission success.
      </div>
    </div>
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref } from 'vue';
// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import ContractVehiclesBannerComponent from '@/components/contract vehicles/ContractVehiclesBannerComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default defineComponent({
  components: {
    HeaderComponent,
    ContractVehiclesBannerComponent,
    FooterComponent
  },
  data() {
    return {};
  },
  setup() {
    return {
    };
  },
});
</script>
<style scoped>
.paragraph-container {
  margin: 40px;
  display: flex;
  margin-left: 100px;
  margin-right: 100px;
}

.paragraph-content {
  font-family: Roboto;
  font-size: 24px;
  font-weight: 400;
  line-height: 35px;
  text-align: left;
  color: #000000;
}
</style>